import { defineComponent } from "vue";
import common from "../core/core";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Swiper as SwiperCreator } from "swiper";

import "@/assets/scss/poda-tv-cloudflare.scss";

const timeToString = (time: number) => {
  time = Math.round(time);
  const m = Math.floor(time / 60);
  const s = time % 60;
  return `${m > 9 ? m.toString() : "0" + m}:${s > 9 ? s.toString() : "0" + s}`;
};

const INIT_CF_PLAYER_STATE = {
  currentTime: "00:00",
  duration: "00:00",
  loadedPercent: 0,
  progressPercent: 0,
  paused: true,
};

/**
 * This component relies heavily on cloudflare-player-sdk.js being called BEFORE this code is executed.
 */
export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
  },
  props: ["cloudflareCustomerId"],
  data() {
    return {
      tvTabSwiper: null,
      tvTabIndex: 0,
      src: "",
      poster: "",
      step: 1,
      cloudflarePlayer: null,
      cloudflarePlayerState: { ...INIT_CF_PLAYER_STATE },
    };
  },
  mounted() {
    this.changeTvTab(0);
    this.tvTabSwiper = new SwiperCreator(".poda-tv-cloudflare-tab-content .swiper-container", {
      slidesPerView: 1,
      allowTouchMove: false,
    });
    this.createVideoPlayer();
  },
  computed: {
    videoIsArchive() {
      return this.step === 3;
    },
    videoIsRecord() {
      return this.step === 4;
    },
    isMainVideo() {
      return this.step === 1 || this.step === 2;
    },
  },
  methods: {
    changeTvTab(index: number) {
      const tabs: any = document.querySelectorAll(".poda-tv-cloudflare .poda-tv-cloudflare-tab-item");
      if (tabs[index]) {
        this.tvTabIndex = index;
        const line: any = document.querySelector(".poda-tv-cloudflare-tabs__line-progress");
        line.style.width = tabs[index].offsetWidth + "px";
        line.style.left = tabs[index].offsetLeft + "px";
      }
      this.tvTabSwiper?.slideTo(index);
    },
    setVideoSrc(src: string, poster: string) {
      this.destructVideoPlayer();
      (
        document.getElementById("tv-cloudflare-player") as HTMLIFrameElement
      ).src = `https://customer-${this.cloudflareCustomerId}.cloudflarestream.com/${src}/iframe?preload=auto`;
      this.createVideoPlayer();
      this.playerSelectStep(1);
    },
    createVideoPlayer() {
      // Initialize cloudflare player

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (Stream) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.cloudflarePlayer = Stream(document.getElementById("tv-cloudflare-player"));
        this.cloudflarePlayer.controls = false;
        this.cloudflarePlayer.addEventListener("durationchange", (e: unknown) => {
          this.cloudflarePlayerState.duration = timeToString(this.cloudflarePlayer?.duration ?? 0);
        });
        this.cloudflarePlayer.addEventListener("timeupdate", (e: unknown) => {
          this.cloudflarePlayerState.currentTime = timeToString(this.cloudflarePlayer?.currentTime ?? 0);
          this.cloudflarePlayerState.progressPercent = Math.floor(
            ((this.cloudflarePlayer?.currentTime ?? 0) / (this.cloudflarePlayer?.duration ?? Infinity)) * 100
          );
        });
        this.cloudflarePlayer.addEventListener("progress", (e: unknown) => {
          const loadedSeconds = this.cloudflarePlayer?.buffered.ranges.find(
            (elem: { start: number; end: number }) => elem.start === 0
          )?.end;
          this.cloudflarePlayerState.loadedPercent = Math.floor(
            (loadedSeconds / (this.cloudflarePlayer?.duration ?? Infinity)) * 100
          );
        });
        this.cloudflarePlayer.addEventListener("play", (e: unknown) => {
          this.cloudflarePlayerState.paused = false;
        });
        this.cloudflarePlayer.addEventListener("pause", (e: unknown) => {
          this.cloudflarePlayerState.paused = true;
        });
      } else {
        console.error("Cloudflare stream player: Initialization attempted without initialized SDK");
      }
    },
    destructVideoPlayer() {
      delete this.cloudflarePlayer;
      this.cloudflarePlayer = null;
      this.cloudflarePlayerState = { ...INIT_CF_PLAYER_STATE };
    },
    playerTogglePlay() {
      if (this.cloudflarePlayer === null) {
        console.warn("Attempt to play video before player initialized");
        return;
      }
      if (this.cloudflarePlayer.paused) {
        this.cloudflarePlayer.play();
      } else {
        this.cloudflarePlayer.pause();
      }
    },
    playerPause() {
      this.cloudflarePlayer?.pause();
    },
    playerSetCurrentTime(e: any) {
      const progress = e.offsetX / e.target.closest(".poda-tv-cloudflare__progress-lines").offsetWidth;
      this.cloudflarePlayer.currentTime = progress * (this.cloudflarePlayer?.duration ?? 0);
    },
    playerSelectStep(step: number) {
      this.step = step;
      switch (step) {
        case 1:
        case 3:
        case 4:
          this.playerPause();
          break;
        case 2:
          this.cloudflarePlayer.currentTime = 0;
          break;
      }
    },
    getTime() {
      return (
        (this.cloudflarePlayerState.currentTime.toString() ?? "0:00") +
        " / " +
        (this.cloudflarePlayerState.duration.toString() ?? "0:00")
      );
    },
  },
  mixins: [common],
});
